import AkerBPLogo from "./akerbp";
export default AkerBPLogo;